import styles from './VoucherInfo.module.scss';
import moment from 'moment';
import { getTranslation } from '../../../../../../utils/translation';
import { VOUCHER_STATUSES } from '../../../../../../constants/enums';

const VoucherInfo = props => {
    const { voucher } = props;

    return (
        <div className={styles.vocuherInfo}>
            <h4 className={styles.title}>{getTranslation('voucherInformationTitle')}</h4>
            <div className='flex'>
                <table className={styles.infoTable}>
                    <tbody>
                        <tr>
                            <th align='left'>{getTranslation('voucherTableCashierCodeColumn')}</th>
                            <td align='right'>{voucher.cashierCode}</td>
                        </tr>
                        <tr>
                            <th align='left'>{getTranslation('voucherTableIdColumn')}</th>
                            <td align='right'>{voucher.id}</td>
                        </tr>
                        <tr>
                            <th align='left'>{getTranslation('voucherTerminalCode')}</th>
                            <td align='right'>{voucher.terminalCode || '-'}</td>
                        </tr>
                        <tr>
                            <th align='left'>{getTranslation('voucherTableAmountDateColumn')}</th>
                            <td align='right' className={styles.green}>
                                {voucher.amount} AZN
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table className={styles.infoTable}>
                    <tbody>
                        <tr>
                            <th align='left'>{getTranslation('voucherTableCreateDateColumn')}</th>
                            <td align='right'>
                                {moment(voucher.createdAt).format('DD MMMM YYYY HH:mm:ss')}
                            </td>
                        </tr>
                        <tr>
                            <th align='left'>{getTranslation('voucherTableExpireDateColumn')}</th>
                            <td align='right'>
                                {moment(voucher.expiredAt).format('DD MMMM YYYY HH:mm:ss')}
                            </td>
                        </tr>
                        {voucher.status === VOUCHER_STATUSES.inactive ? (
                            <tr>
                                <th align='left'>
                                    {getTranslation('voucherTableIssueDateColumn')}
                                </th>
                                <td align='right'>
                                    {voucher.issuedAt
                                        ? moment(voucher.issuedAt).format('DD MMMM YYYY HH:mm:ss')
                                        : '-'}
                                </td>
                            </tr>
                        ) : voucher.status === VOUCHER_STATUSES.cancelled ? (
                            <tr>
                                <th align='left'>
                                    {getTranslation('voucherTableCancellationDateColumn')}
                                </th>
                                <td align='right'>
                                    {moment(voucher.cancellationTime).format(
                                        'DD MMMM YYYY HH:mm:ss'
                                    )}
                                </td>
                            </tr>
                        ) : (
                            <tr className={'v-hidden'}>
                                <th>hidden</th>
                            </tr>
                        )}
                        <tr className={'v-hidden'}>
                            <th>hidden</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default VoucherInfo;
